module.exports = __webpack_public_path__ + "img/buy_super_cn.2e56cec3.png";